import Stepper from "@/components/common/Stepper";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { hooks as h } from "@/hooks";
import { Outlet, createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";

const NewDiaryFormLayout = () => {
	const { templateId } = Route.useParams();
	const router = useRouter();
	const currentPath = router.state.location.pathname;
	const { steps, setCurrentStep } = useTemplateNavigationStore();

	h.useNav([
		{ label: "New Diary", route: { to: currentPath } },
		{
			label: "Template",
			route: {
				to: Route.to,
				params: { templateId: templateId },
			},
		},
	]);

	// Memoize the route to step index mapping
	const routeToStepIndex = useMemo(
		() => ({
			"/new/diary/$templateId/organisation": 0,
			"/new/diary/$templateId/trackers": 1,
			"/new/diary/$templateId/events": 2,
			"/new/diary/$templateId/events/injection": 2,
			"/new/diary/$templateId/events/injection/details": 2,
			"/new/diary/$templateId/name": 3,
		}),
		[],
	);

	// Update current step based on route
	useEffect(() => {
		const stepIndex = routeToStepIndex[currentPath];
		if (stepIndex !== undefined) {
			setCurrentStep(stepIndex);
		}
	}, [currentPath, routeToStepIndex, setCurrentStep]);

	return (
		<section className="space-y-6 xl-width">
			<Stepper steps={steps} />
			<Outlet />
		</section>
	);
};

export const Route = createFileRoute("/_app/new/diary/$templateId")({
	component: NewDiaryFormLayout,
});
